import { v4 as uuidv4 } from "uuid";
import { arrayMoveImmutable } from "array-move";
import { toast } from "@/helpers/toast"

import { t } from "../../../langs/useTranslation";

export function uuid(...args) {
  return uuidv4(...args);
}

/**
 * 修改某个节点
 * @param list 树状列表
 * @param id 要修改的节点key
 * @param obj 给节点修改的字段对象
 * @returns {[]}
 */
export function modifyDataNode(list, id, obj) {
  const dList = [];
  list.forEach(item => {
    if (id === item.key) {
      dList.push({
        ...item,
        ...obj
      });
    } else if (item.children) {
      dList.push({
        ...item,
        children: modifyDataNode(item.children, id, obj)
      });
    } else {
      dList.push(item);
    }
  });
  return dList;
}

/**
 * 批量更改树文件节点信息
 * @param tree
 * @param updateList [{ fileId: '', updateObj: {} }]
 * @returns {[],change} {树目录，是否有更改}
 */
export function batchModifyNode(tree, updateList) {
  let change = false;

  const mapList = list => {
    const dataList = [];

    list.forEach(item => {
      let itemData = { ...item };

      const data = updateList.find(d => d.fileId === item.fileId);
      if (data && itemData.fileName !== data.updateObj.fileName) {
        const { updateObj } = data;
        change = true;
        itemData = {
          ...itemData,
          ...updateObj
        };
      }

      if (item.children && item.children.length > 0) {
        itemData = {
          ...itemData,
          children: mapList(item.children)
        };
      }

      dataList.push(itemData);
    });

    return dataList;
  };

  const list = mapList(tree);

  const obj = {};
  obj.list = list;
  obj.change = change;
  return obj;
}

/**
 * 获取树列表中所有的某个值
 * @param tree
 * @param key 获取节点的某个参数
 * @returns {[]} 通过传入某个参数，获取目录树里所有的某个值
 */
export function getAllIdInTree(tree, key) {
  try {
    if (!tree.length > 0) {
      return [];
    }

    const list = [];

    const mapList = treeList => {
      treeList.forEach(item => {
        if (item[key]) {
          list.push(item[key]);
        }
        if (item.children && item.children.length > 0) {
          mapList(item.children);
        }
      });
    };
    mapList(tree);

    return list;
  } catch (e) {
    return [];
  }
}

/**
 * 给树列表添加parentId
 * @param treeData
 * @returns {*}
 */
export function treeAddParentId(treeData) {
  const mapTree = (tree, parentId = "") => {
    return tree.map(item => {
      const info = { ...item, parentId };

      if (item.children && item.children.length) {
        info.children = mapTree(item.children, info.key);
      }

      return info;
    });
  };

  return mapTree(treeData);
}

/**
 * 查询该节点有多少个子节点
 * @param nodeInfo
 * @param callback () => nodeInfo
 * @returns {number}
 */
export function getChildrenNum(nodeInfo, callback) {
  if (!(nodeInfo.children && nodeInfo.children.length)) return 0;

  let count = 0;
  const mapTree = tree => {
    tree.forEach(item => {
      count += 1;
      if (callback) {
        callback(item);
      }

      if (item.children && item.children.length) {
        mapTree(item.children);
      }
    });
  };

  mapTree(nodeInfo.children);
  return count;
}

/**
 * 获取树列表中的某个节点信息
 * @param tree
 * @param key
 * @param id
 * @param getList 传true获取列表,否则获取对象
 * @returns {{}} 通过匹配某个节点键的值，获取这个节点信息
 */
export function getInfoByFileId(tree, key, id, getList = false) {
  if (!id) {
    return getList ? [] : {};
  }

  let info = {};
  const list = [];

  const mapList = treeList => {
    treeList.forEach(item => {
      if (item[key] === id) {
        if (getList) {
          list.push(item);
        } else {
          info = { ...item };
        }
      }
      if (item.children && item.children.length > 0) {
        mapList(item.children);
      }
    });
  };
  mapList(tree);

  return getList ? list : info;
}

/**
 * 树列表中匹配到的值 返回给一个回调中
 * @param list 树列表
 * @param keyword 关键字
 * @param back 回调
 */
export function matchingTreeNode(list, keyword, back) {
  list.forEach(item => {
    if (item.title.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
      if (back) back(item);
    }
    if (item.children && item.children.length) {
      matchingTreeNode(item.children, keyword, back);
    }
  });
}

/**
 * 搜索目录树匹配的节点
 * @param tree
 * @param keyword
 * @returns {*[]|*}
 */
export function onSearchTree(tree, keyword) {
  const searchTree = [];
  const matchingList = [];
  let matchingParentList = [];

  matchingTreeNode(tree, keyword, item => {
    matchingList.push(item.key);
  });

  if (!matchingList.length) {
    return {
      searchTree: [],
      expandedKeys: []
    };
  }

  matchingList.forEach(nodeId => {
    matchingParentList = matchingParentList.concat(
      findParent(nodeId, tree) || []
    );
  });
  [...new Set(matchingList.concat(matchingParentList))].forEach(nodeId => {
    searchTree.push(getInfoByFileId(tree, "key", nodeId));
  });

  const updateSearchList = sortTreeList(
    translateDataToTree(searchTree, tree[0].parentId)
  );

  return {
    searchTree: updateSearchList,
    expandedKeys: matchingParentList.filter(item => {
      if (!matchingList.includes(item)) {
        return true;
      }
      // 判断子节点是否还有匹配到的节点
      const idList = [];
      const searchInfo = getInfoByFileId(updateSearchList, "key", item);

      if (searchInfo.children && searchInfo.children.length) {
        matchingTreeNode(searchInfo.children, keyword, item => {
          idList.push(item.key);
        });
      }

      return idList.length;
    }),
    firstSearchNode: matchingList[0]
      ? getInfoByFileId(tree, "key", matchingList[0])
      : undefined
  };
}

/**
 * 添加单个节点
 * @param tree 树目录
 * @param id 添加的父节点id
 * @param node 节点信息
 * @param front 是否将新添加的节点放在后面
 * @returns {[]} 传入目录结构树个父节点key 添加一个节点
 */
export function addNode(tree, id, node, front = false) {
  if (!id) {
    const list = [...tree];
    if (front) {
      list.push({ ...node });
    } else {
      list.unshift({ ...node });
    }
    return list;
  }

  const add = list => {
    const dList = [];

    list.forEach(item => {
      if (item.key === id) {
        const l = item.children ? [...item.children] : [];
        if (front) {
          l.push({ ...node });
        } else {
          l.unshift({ ...node });
        }

        dList.push({ ...item, children: l });
      } else if (item.children) {
        dList.push({ ...item, children: add(item.children) });
      } else {
        dList.push(item);
      }
    });

    return dList;
  };

  const list = add(tree);
  return list;
}

/**
 * 移动单个节点
 * @param tree 树目录
 * @param id 要移动的节点id
 * @param isDown 是否下移
 * @returns {[]} 传入目录结构树个父节点key 添加一个节点
 */
export function moveNode(tree, id, isDown) {
  let fromTarget,
    toTarget,
    sortedList = [];
  const move = list => {
    const dList = [];
    const targetIndex = list.findIndex(item => item.key === id);
    if (targetIndex > -1) {
      let toIndex;
      if (isDown) {
        toIndex = targetIndex + 1 === list.length ? 0 : targetIndex + 1;
      } else {
        toIndex = targetIndex - 1;
      }
      fromTarget = list[targetIndex];
      toTarget = list[toIndex];
      list = arrayMoveImmutable(list, targetIndex, toIndex);
      sortedList = list;
    }
    list.forEach(item => {
      if (item.children) {
        dList.push({ ...item, children: move(item.children) });
      } else {
        dList.push(item);
      }
    });

    return dList;
  };

  const list = move(tree);
  return { tree: list, list: sortedList, fromTarget, toTarget };
}

/**
 * 批量添加节点
 * @param tree 树目录
 * @param id 添加的父节点id
 * @param nodes 节点信息数组
 * @returns {[]} 传入目录结构树个父节点key 添加一个节点
 */
export function batchAddNode(tree, id, nodes) {
  if (!id) {
    return [...nodes, ...tree];
  }

  const add = list => {
    const dList = [];

    list.forEach(item => {
      if (item.key === id) {
        let l = item.children ? [...item.children] : [];
        l = [...nodes, ...l];
        dList.push({ ...item, children: l });
      } else if (item.children) {
        dList.push({ ...item, children: add(item.children) });
      } else {
        dList.push(item);
      }
    });

    return dList;
  };

  const list = add(tree);
  return list;
}

/**
 * 给某个节点添加父节点
 * @param tree 数列表
 * @param changeId 要添加父节点的节点id
 * @param addNode 要添加的父节点信息
 * @returns {[]}
 */
export function addParentNode(tree, changeId, addNode) {
  const treeMap = list => {
    const dList = [];
    list.forEach(item => {
      if (item.key === changeId) {
        dList.push({ ...addNode, children: [item] });
      } else if (item.children && item.children.length > 0) {
        dList.push({ ...item, children: treeMap(item.children) });
      } else {
        dList.push(item);
      }
    });
    return dList;
  };

  return treeMap(tree);
}

/**
 * 添加（修改）数列表层级
 * @param tree 树列表
 * @param level 第一层等级
 */
export function resetLevel(tree, level) {
  if (!Array.isArray(tree)) return [];
  return tree.map(item => {
    if (item.children && item.children.length) {
      return {
        ...item,
        nodeLevel: level + 1,
        children: resetLevel(item.children, level + 1)
      };
    }
    return { ...item, nodeLevel: level + 1 };
  });
}

/**
 * 删除节点
 * @param tree
 * @param key
 * @returns {[]} 通过传入目录结构和key，删除该项
 */
export function deleteNode(tree, key) {
  const mapItem = (list, i) => {
    if (list.some(item => item.key === i)) {
      return list.filter(item => item.key !== i);
    }

    const newList = [];
    list.forEach(item => {
      if (item.children) {
        const newChildList = mapItem(item.children, i);
        newList.push({ ...item, children: newChildList });
      } else {
        newList.push(item);
      }
    });
    return newList;
  };
  return mapItem(tree, key);
}

/**
 * 拖拽节点（目录树）
 * @param tree
 * @param info 树拖动返回的数据
 * @returns {*[]} 通过传入目录和拖动的数据，返回新的树
 */
export function dragNode(tree, info) {
  const dropKey = info.node.props.eventKey;
  const dragKey = info.dragNode.props.eventKey;

  const treeKeys = getAllIdInTree(tree, "key");
  if (!treeKeys.includes(dragKey) || !treeKeys.includes(dropKey)) {
    toast.info(
      t({
        defaultMessage: "操作的节点已不存在，请重新操作"
      })
    );
    return tree;
  }

  const dropPos = info.node.props.pos.split("-");
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  const loop = (data, key, callback) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key === key) {
        return callback(data[i], i, data);
      }
      if (data[i].children && data[i].children.length > 0) {
        loop(data[i].children, key, callback);
      }
    }
  };
  const treeData = [...tree];

  let dragObj;
  loop(treeData, dragKey, (item, index, arr) => {
    arr.splice(index, 1);
    if (info.dragOver) {
      dragObj = { ...item, parentId: Number(dropPos[0]) > 0 ? dropKey : "" };
    } else {
      dragObj = item;
    }
  });

  if (!dragObj) {
    toast.info(t({ defaultMessage: "该节点已被删除" }));
    return tree;
  }

  if (!info.dropToGap) {
    loop(treeData, dropKey, item => {
      item.children = item.children || [];
      // item.children.push(dragObj)
      item.children.unshift(dragObj);
    });
  } else if (
    (info.node.props.children || []).length > 0 &&
    info.node.props.expanded &&
    dropPosition === 1
  ) {
    loop(treeData, dropKey, item => {
      item.children = item.children || [];
      item.children.unshift(dragObj);
    });
  } else {
    let ar;
    let i;
    loop(treeData, dropKey, (item, index, arr) => {
      ar = arr;
      i = index;
    });
    if (dropPosition === -1) {
      ar.splice(i, 0, dragObj);
    } else {
      ar.splice(i + 1, 0, dragObj);
    }
  }
  return treeData;
}

export function onDragNode(tree, info, treeId) {
  // 目标节点
  const dropKey = info.node.props.eventKey;
  // 拖拽节点
  const dragKey = info.dragNode.props.eventKey;

  const treeKeys = getAllIdInTree(tree, "key");
  if (!treeKeys.includes(dragKey) || !treeKeys.includes(dropKey)) {
    toast.info(
      t({
        defaultMessage: "操作的节点已不存在，请重新操作"
      })
    );
    return {};
  }

  const dropPos = info.node.props.pos.split("-");
  const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

  const loop = (data, key, callback) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].key === key) {
        return callback(data[i], i, data);
      }
      if (data[i].children && data[i].children.length > 0) {
        loop(data[i].children, key, callback);
      }
    }
  };
  let treeData = [...tree];
  const updateList = {};

  let dragObj;
  loop(treeData, dragKey, item => {
    if (info.dragOver) {
      dragObj = {
        ...item,
        parentId: Number(dropPos[0]) > 0 ? dropKey : treeId
      };
    } else {
      dragObj = item;
    }
  });
  treeData = deleteNode(treeData, dragObj.nodeId);

  if (!dragObj) {
    toast.info(t({ defaultMessage: "该节点已被删除" }));
    return {};
  }

  if (!info.dropToGap) {
    loop(treeData, dropKey, item => {
      updateList[dragKey] = {
        parentId: item.key,
        sortId: getMinSortId(item.children) - 100
      };
    });
  } else if (
    (info.node.props.children || []).length > 0 &&
    info.node.props.expanded &&
    dropPosition === 1
  ) {
    loop(treeData, dropKey, item => {
      updateList[dragKey] = {
        parentId: item.key,
        sortId: getMinSortId(item.children) - 100
      };
    });
  } else {
    loop(treeData, dropKey, (item, index, arr) => {
      if (dropPosition === -1) {
        updateList[dragKey] = {
          parentId: item.parentId || treeId,
          sortId: index * 100 + 1
        };

        arr.forEach((innerItem, i) => {
          let sortId;
          if (i < index) {
            sortId = i * 100 + 1;
          } else {
            sortId = (i + 1) * 100 + 1;
          }

          updateList[innerItem.key] = {
            parentId: (item && item.parentId) || treeId,
            sortId
          };
        });
      } else {
        updateList[dragKey] = {
          parentId: item.parentId || treeId,
          sortId: (index + 1) * 100 + 1
        };

        arr.forEach((innerItem, i) => {
          let sortId;
          if (i < index + 1) {
            sortId = i * 100 + 1;
          } else {
            sortId = (i + 1) * 100 + 1;
          }

          updateList[innerItem.key] = {
            parentId: (item && item.parentId) || treeId,
            sortId
          };
        });
      }
    });
  }
  return updateList;
}

export function getMinSortId(list, max = false) {
  if (!Array.isArray(list)) return 1;

  if (list && list.length) {
    if (!max) {
      return (
        Math.min.apply(
          null,
          list
            .filter(item => item.sortId !== undefined)
            .map(item => item.sortId)
        ) || 1
      );
    }
    return (
      Math.max.apply(
        null,
        list.filter(item => item.sortId !== undefined).map(item => item.sortId)
      ) || 1
    );
  }
  return 1;
}

/**
 * 拖拽（脑图）
 * @param tree 数列表
 * @param dragId 拖拽的节点id
 * @param parentId 拖拽目标节点id
 * @returns {[]|*[]}
 */
export function mindMapDrag(tree, dragId, parentId) {
  const dragInfo = getInfoByFileId(tree, "key", dragId);
  const treeData = deleteNode(tree, dragId);

  if (parentId === "") {
    const list = [...treeData];
    list.push({ ...dragInfo });

    return list;
  }

  const mapTree = list => {
    const dList = [];

    list.forEach(item => {
      if (item.key === parentId) {
        const l = item.children ? [...item.children] : [];
        l.push({ ...dragInfo });

        dList.push({ ...item, children: l });
      } else if (item.children) {
        dList.push({ ...item, children: mapTree(item.children) });
      } else {
        dList.push(item);
      }
    });

    return dList;
  };

  return mapTree(treeData);
}

/**
 * 获取这个节点父节点列表
 * @param childrenId 节点key
 * @param arr 列表
 * @param path 父节点key列表（默认空）
 * @returns {*[]|undefined}
 */
export function findParent(childrenId, arr, path = []) {
  for (let i = 0; i < arr.length; i++) {
    const tmpPath = path.concat();
    tmpPath.push(arr[i].key);
    if (childrenId === arr[i].key) {
      return tmpPath;
    }
    if (arr[i].children) {
      const findResult = findParent(childrenId, arr[i].children, tmpPath);
      if (findResult) {
        return findResult;
      }
    }
  }
}

/**
 * 文件夹文件列表转化成文件类型列表
 * @param data
 * @returns {*}
 */
export function translateTypeTree(data) {
  const fileList = data.filter(item => item.type !== "empty");
  const folderList = data
    .filter(item => item.type === "empty")
    .map(item => {
      const itemObj = { ...item };
      delete itemObj.children;
      return itemObj;
    });

  const typeObj = {};
  fileList.forEach(item => {
    if (item.type in typeObj) {
      typeObj[item.type] = typeObj[item.type].concat([item]);
    } else {
      typeObj[item.type] = [item];
    }
  });

  const fileTypeList = Object.keys(typeObj).map(item => ({
    title: item,
    fileName: "",
    key: getRandomString(6),
    type: "empty",
    edit: false,
    fileId: "",
    parentId: "0",
    knowledgeBaseFileId: "",
    children: typeObj[item]
  }));
  return folderList.concat(fileTypeList);
}

/**
 * 目录数据列表转树目录树形列表
 * @param data 目录数据列表
 * @param parentId 父节点id
 * @returns {*[]}
 */
export function translateDataToTree(data, parentId = "1") {
  const tree = [];

  data.forEach(item => {
    if (item.parentId === parentId) {
      let obj = item;
      if (item.content) {
        obj = {
          ...item.content.attribute,
          ...item,
          key: item.nodeId,
          edit: false,
          nodeSourceKey:
            (item.content.attribute && item.content.attribute.key) ||
            item.nodeId,
          attribute: item.content.attribute
        };
      }

      const temp = translateDataToTree(data, obj.key);
      if (temp.length > 0) {
        obj.children = temp;
      }
      tree.push(obj);
    }
  });

  return tree;
}

/**
 * 通过sortId给树状数据排序
 * @param data 目录树状结构
 * @returns {*}
 */
export function sortTreeList(data) {
  const list = data.sort((a, b) => (a.sortId || 0) - (b.sortId || 0));

  return list.map(item => {
    if (item.children && item.children.length > 0) {
      return { ...item, children: sortTreeList(item.children) };
    }
    return item;
  });
}

/**
 * 获取第一个文件或第一个节点
 * @param tree
 * @returns {{}|*} 传入树状图返回第一个文件或者第一个节点
 */
export function getFirstNodeOrFirstFile(tree) {
  try {
    if (!tree.length > 0) {
      return {};
    }

    let node = {};
    let flag = true;

    const mapTree = list => {
      list.forEach(item => {
        if (item.type !== "empty" && flag) {
          flag = false;
          node = item;
        }
        if (item.children && item.children.length > 0 && flag) {
          mapTree(item.children);
        }
      });
    };
    mapTree(tree);

    if (!flag) {
      return node;
    }
    return tree[0];
  } catch (e) {
    return {};
  }
}

export function getRandomString(e) {
  e = e || 32;
  const t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const a = t.length;
  let n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}
